<style lang="stylus" scoped>
@import '../cardMap.stylus';
</style>
<template>
  <div class="map-card" v-if="cardItemLeth>0">
    <div class="map-card-t">
      <el-row>
        <el-col :span="12">
          <div class="font18">{{details.provinceName?details.provinceName:'全部'}}</div>
        </el-col>
        <el-col :span="12">
          <div class="t-r">
            <el-button v-if="details.provinceName&&details.provinceName!='合计'" @click="goDetails">查看详情</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="map-card-cont">
      <el-scrollbar style="height:100%;">
        <div
          class="map-card-lib"
          @click="timeEvent(it,index)"
          v-for="(it,index) in cardItem"
          :key="index"
          :class="it.selected?'map-card-active':''"
        >
          <div class="_lib1" v-if="it.dataType==1">
            <div
              style="position: relative;
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;"
            >
              <img
                style="position: absolute;
 top: 0;
 left: 0;"
                src="../../../assets/images/002.png"
              >
              <img
                style="
 transition: all 1s;"
                src="../../../assets/images/001.png"
                :class="{'dong':dong}"
              >
            </div>
            <span style="color:#017BFF;">指定时间新增</span>
            {{titleArr[allTab]}}
          </div>
          <div class="_lib1" v-else>{{handleMapTitle(it.dataType,it.timeSection)}}</div>
          <div class="_lib2">{{it.timeSection}}</div>
          <div class="_lib3">{{initNum(it.count)}}</div>
          <div class="m-t-2 t-c">
            <el-row class="color1 font12">
              <el-col :span="4">
                <div class="t-l">个人单卡</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">个人多卡</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">企业单卡</div>
              </el-col>
              <el-col :span="4">
                <div class="t-r">企业多卡</div>
              </el-col>
            </el-row>
            <el-row class="m-t font12">
              <el-col :span="4">
                <div class="t-l">{{initNum(it.personalSingleCard)}}</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">{{initNum(it.personalMoreCard)}}</div>
              </el-col>
              <el-col :span="8">
                <div class="t-c">{{initNum(it.companySingleCard)}}</div>
              </el-col>
              <el-col :span="4">
                <div class="t-r">{{initNum(it.companyMoreCard)}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import http from '@/api/cardData'
import Bus from '@/utils/Bus.js'
export default {
  name: 'mapCard',
  data() {
    return {
      cardItem: [],
      cardItemLeth: 0,
      details: {provinceCode: null}
    }
  },
  props: {
    // areaList:Array
    time: Array,
    changeType: {
      type: Function
    },
    dong: Boolean //控制动画变量
  },
  watch: {
    time: function(value, oldValue) {
      console.log('1');
      this.initData(this.details)
    },
    '$store.state.app.tab': function(value, oldValue) {
      console.log('2');
      this.initData(this.details)
    }
  },
  created() {},
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
    titleArr: function() {
      return this.$store.state.app.titleArr
    }
  },
  mounted() {
    Bus.$on('selectProvinceIt', e => {
      if (e) {
        this.details = e
      }
      this.initData(e)
    })
  },
  methods: {
    initData(it) {
      // console.log(it);
      it = it ? it : { provinceCode: null }
      let that = this,
        _option = {
          provinceCode: it.provinceCode,
          timeSection: [this.time[0] + '', this.time[1] + '']
        }
      http[that.allTab].provinceDate(_option).then(e => {
        that.cardItem = e.data
        that.cardItemLeth = e.data.length
      })
    },
    initNum(num) {
      num = this.format(num) + ''
      if (num.indexOf('.') == -1) {
        return num
      }
      return num.split('.')[0]
    },
    format(num) {
        var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                return $1+",";
                });
        })
        return res;
    },
    timeEvent(it, index) {
      Bus.$emit('dataType', index + 1)
      // this.$set(it,'status',true)
      this.changeType({
        num: it.dataType,
        title: index + 1
      })
    },
    //  handleMapTitle(e,year){
    //       let index=e||6;
    //       if(index==1){
    //               return "指定时间新增发卡量"
    //         }else if(index==2){
    //              return "昨日新增发卡量"
    //         }else if(index==3){
    //              return "本月新增发卡量"
    //         }else if(index==4){
    //              return "本季度新增发卡量"
    //         }else if(index==5){
    //             return year.slice(0, 4)+"年新增发卡量"
    //         }else{
    //             return "历史累计发卡量"
    //         }
    // },
    goDetails() {
      this.$router.push({
        name: 'cardProvince',
        query: {
          provinceCode: this.details.provinceCode,
          provinceName: this.details.provinceName,
          timeSection: JSON.stringify(this.$parent.timeSection)
        }
      })
    }
  }
}
</script>
<style scoped>
.dong {
  transform: rotate(360deg);
}
</style>

